import React, { useState } from 'react'
import { useIntl } from 'react-intl'
import { useConfig } from 'msp-integrations'
import NewsletterForm from '@molecules/NewsletterForm/NewsletterForm'

const NewsletterWrapper = ({
  buttonClassname,
  onSuccess,
  noDescription = false,
  isDarkMode = false
}: {
  buttonClassname?: string
  onSuccess?: () => void
  noDescription: boolean
  isDarkMode: boolean
}) => {
  const { formatMessage } = useIntl()
  const [showConfirmationMessage, setShowConfirmationMessage] = useState(false)
  const {
    theme: { font }
  } = useConfig()

  return showConfirmationMessage ? (
    <div className={`${font.regular} text-16 tracking-0`}>
      {formatMessage({
        defaultMessage:
          'Thank you for your registration. You will soon receive an email to confirm your email address.',
        id: 'msp.newsletter.success_message'
      })}
    </div>
  ) : (
    <NewsletterForm
      id={'newsletter-form-wrapper'}
      buttonClassname={buttonClassname}
      noDescription={noDescription}
      isDarkMode={isDarkMode}
      onSuccess={() => {
        setShowConfirmationMessage(true)
        onSuccess && onSuccess()
      }}
      newsletterSource='form'
    />
  )
}

export default NewsletterWrapper
